export default __webpack_public_path__ + "static/media/akademia-white.291d2002.svg";